import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicHome({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M7.81 4.82l-4.48 3.7v4.86c0 .21.18.38.4.38h2.72a.4.4 0 00.38-.4v-2.32a.4.4 0 01.4-.39h1.55a.4.4 0 01.39.4v2.32a.39.39 0 00.38.39h2.73c.21 0 .39-.17.39-.38V8.5L8.19 4.82a.3.3 0 00-.38 0zm5.05.84V2.29a.3.3 0 00-.3-.29h-1.35a.3.3 0 00-.3.3v1.76l-2.17-1.8a1.17 1.17 0 00-1.48 0L1.1 7.34a.3.3 0 00-.04.41l.62.76a.3.3 0 00.4.04L7.8 3.84a.3.3 0 01.38 0l5.71 4.7a.3.3 0 00.41-.03l.62-.76a.3.3 0 00-.04-.4l-2.03-1.68z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicHome.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicHome.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicHome svgRef={ref} {...props} />);
export default ForwardRef;
